<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        <span> {{ row.index + 1 }} </span>
                    </template>
                    <template v-slot:cell(nominativo)="{ item }">
                        <span>{{ item.cognome }} {{ item.nome }}</span>
                        <span style="display: block">({{ item.identificativo }})</span>
                    </template>
                    <template v-slot:cell(eta)="{ item }">
                        <span>{{ calcoloEta(item.dataNascita) }}</span>
                    </template>
                    <template v-slot:cell(presidio)="{ item }">
                        <span>{{ item.denominazionePresidio }}</span>
                    </template>
                    <template v-slot:cell(settings)="{ item }">
                        <span>{{ item.settingDescrizione }}</span>
                    </template>
                    <template v-slot:cell(camera)="{ item }">
                        <span class="sa-table-span-label-primary">Piano: {{ item.nomePiano }}</span>
                        <span class="sa-table-span-label-primary">Stanza: {{ item.nomeStanza }}</span>
                        <span class="sa-table-span-label-primary">Letto: {{ item.nomeLetto }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <!-- <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Ospite" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <b-icon icon="book" variant="outline-sucess"></b-icon>
                            </b-button>
                        </b-container> -->

                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Paziente" @click="onOpenSchedaPaziente(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <b-icon icon="book" variant="outline-sucess"></b-icon>
                            </b-button>
                            <!--   <b-button v-b-tooltip.hover title="Stampa" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onClickStampa(row.item)">
                                <b-icon icon="printer"></b-icon>
                            </b-button> -->
                            <print-component :linkPrintReport="linkPrintReport(row.item)" :typeButton="'small'" :documentRepository="false"></print-component>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
            <b-modal ref="mdlStampaReferto" size="xl" scrollable>
                <vue-pdf-embed ref="pdfVueEmbeded" :source="stampaReport" allowfullscreen></vue-pdf-embed>
                <template #modal-footer>
                    <b-button size="sm" variant="outline-secondary" @click="onClickPrint()">
                        <b-icon icon="printer"></b-icon>
                        Stampa
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { VuePdfEmbed, PrintComponent },
    data() {
        return {
            rows: 0,
            pathResourceStampa: "/rsaprintdata/folder",
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaospiti/archivio",
            // pathResource: "/ospiti",
            filtroGestioneOspitiArchivio: {},
            items: [],
            listKey: 0,
            stampaReport: null,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Numero Cartella",
                    key: "numero",
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    sortable: true,
                },
                {
                    label: "Età",
                    key: "eta",
                },
                { label: "Presidio", key: "presidio" },
                {
                    label: this.getLabelTraduora("nurity.accettazione.setting"),
                    key: "settings",
                },
                /*  { label: "Numero telefono", key: "telefono" },
                {
                    label: "Email",
                    key: "email",
                }, */
                {
                    label: "Camera",
                    key: "camera",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        linkPrintReport(item) {
            return this.pathResourceStampa + "?idAccettazione=" + item.id;
        },
        onClickStampa(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
            axios
                .get(link, { params: { idAccettazione: item.id } })
                .then((response) => {
                    me.stampaReport = "data:application/pdf;base64," + response.data.data;
                    me.$refs.mdlStampaReferto.show();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneOspitiArchivio"]) {
                me.filtroGestioneOspitiArchivio = JSON.parse(sessionStorage["filtroGestioneOspitiArchivio"]);
            }

            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroGestioneOspitiArchivio.page = me.currentPage;
            me.filtroGestioneOspitiArchivio.forPage = me.perPage;
            //      if (me.filtroGestioneOspitiArchivio.idPresidio) {
            axios
                .get(link, { params: me.filtroGestioneOspitiArchivio })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    // this.$emit("afterLoadData");
                })
                .catch(() => {
                    // this.$emit("afterLoadData");
                });
            // } else {
            //     this.$emit("afterLoadData");
            //     this.$bvModal.msgBoxOk("Inserire Presidio", {
            //         title: "ATTENZIONE",
            //         size: "sm",
            //         okVariant: "outline-danger",
            //     });
            // }
        },
        onEdit(item) {
            let me = this;
            me.$router.push("/rsagestioneospiti/schedaospite/view/" + item.id);
        },

        onOpenSchedaPaziente(item) {
            let me = this;
            me.$router.push("/rsapaziente/view/" + item.id);
        },
        resetList() {
            let me = this;
            me.items = [];
        },
    },
};
</script>
<style></style>
